import React, { Fragment, useEffect, useState } from "react";
import { Button, IconButton } from "@mui/material";
import { AssetLocation, AssetLocationTypes } from "../../../../logic/api";
import LocationPickerDialog from "../../../pickers/locationPicker/LocationPickerDialog";
import flex from "../../../../styles/flex";
import { FiTrash } from "react-icons/fi";
import FloatingInputLabel from "../components/FloatingInputLabel";
import { useTranslation } from "react-i18next";


const LocationField: React.FunctionComponent<{
    label: string,
    value: string;
    testId?: string;
    onChange: (value: string | null) => void;
    selectionTypes: AssetLocationTypes[],
    displayTypes: AssetLocationTypes[],
}> = (props) => {
    let initalValue: AssetLocation | null = null;

    if (props.value != null) {
        try {
            initalValue = JSON.parse(props.value);
        } catch (ex) {
            initalValue = null;
        }

    }

    const [value, setValue] = useState<AssetLocation | null>(initalValue);
    const [showLocationPicker, setShowLocationPicker] = useState<boolean>(false);
    const { t } = useTranslation();

    useEffect(() => {
        setValue(initalValue);
    }, [props.value]);
    return (
        <Fragment>
            <LocationPickerDialog
                title={t("keys.labels.selectLocation")}
                show={showLocationPicker}
                displayTypes={props.displayTypes}
                selectionTypes={props.selectionTypes}
                onChange={(location) => {
                    if (location != null) {
                        setValue(location);
                        props.onChange(JSON.stringify(location));
                    }

                    setShowLocationPicker(false);
                }}
            />
            <FloatingInputLabel label={props.label}>
                <div style={props.label == "" ? {} : { textAlign: "left", border: "solid 1px #eee", borderRadius: 5 }}>

                    {value == null && (
                        <div style={props.label == "" ? {} : { margin: 10 }}>
                            <Button data-testid={props.testId} style={{ width: "100%" }} variant="contained" color="secondary" onClick={() => {
                                setShowLocationPicker(true);
                            }}>{t("general.select")}</Button>
                        </div>
                    )}
                    {value != null && (
                        <Fragment>

                            <div style={flex.flexFill}>
                                <div style={{ margin: 5, marginTop: 10, padding: 5, textAlign: "center", backgroundColor: "#F8F8F8", borderRadius: 5 }}>
                                    <div>{value.parentName}</div>
                                    <div><b>{value.name}</b></div>
                                </div>
                            </div>

                            <div style={flex.flexRows}>


                                <div style={flex.flexFill}>
                                    <div style={{ margin: 5 }}>
                                        <Button
                                            style={{ width: "100%" }}
                                            variant="contained"
                                            onClick={() => {
                                                setShowLocationPicker(true);
                                            }}>{t("general.change")}</Button>
                                    </div>
                                </div>





                                <div style={flex.flexAuto}>
                                    <IconButton
                                        onClick={() => {
                                            setValue(null);
                                            props.onChange(null);
                                        }}
                                    >
                                        <FiTrash />
                                    </IconButton>
                                </div>

                            </div>
                        </Fragment>
                    )}
                </div>
            </FloatingInputLabel>
        </Fragment >
    );
}

export default LocationField;